import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core'
import { IDynamicFormModel } from '@adex/shared/modules/dynamic-form/models/dynamic-form.model'
import { FormControl } from '@angular/forms'
import { combineLatest, ReplaySubject, timer } from 'rxjs'
import { map, shareReplay, startWith, takeUntil } from 'rxjs/operators'
import { IRegisterFormData } from '@adex/shared/models/auth/register-form-data'
import { IBaseForm } from '../../models/base-form'


@Component({
  selector: 'adex-register',
  templateUrl: './register.component.html',
  styleUrls: [ './register.component.scss' ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class RegisterComponent implements IBaseForm<IRegisterFormData> {

  public validForm$: ReplaySubject<boolean> = new ReplaySubject(1)
  public changeForm: IRegisterFormData
  public acceptCheckboxControl = new FormControl(false)

  @Input() public loadingFormState: boolean
  @Input() public model: IDynamicFormModel
  @Output() public submitForm: EventEmitter<IRegisterFormData> = new EventEmitter()


  public disabledButton$ = combineLatest([ this.validForm$, this.acceptCheckboxControl.valueChanges ]).pipe(
    map(([ validForm, accept ]) => !(validForm && accept)),
    startWith(true),
    shareReplay(1)
  )

  public onChangeForm(formValue: IRegisterFormData): void {
    this.changeForm = formValue
  }

  public async onSubmit(): Promise<void> {
    const disabledButton = await this.disabledButton$.pipe(takeUntil(timer(0))).toPromise()
    if (disabledButton) return
    this.submitForm.emit(this.changeForm)
  }

}
